import React, { useEffect, useState } from "react";
import { Images } from "constants/Images";
import InputBox from "components/comman/InputBox";
import "stylesheets/AddFixtureModal.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import Button from "components/button";
import { useNavigate } from "react-router-dom";
import SelectBox from "components/comman/SelectBox";

const generateRandomKey = (length = 4) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let key = "";
  for (let i = 0; i < length; i++) {
    key += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return key;
};

const typeList = [
  {
    id: generateRandomKey(),
    value: "",
    name: "Select fixture type",
  },
  {
    id: generateRandomKey(),
    value: "2 Compartment Sink",
    name: "2 Compartment Sink",
  },
  {
    id: generateRandomKey(),
    value: "3 Compartment Sink",
    name: "3 Compartment Sink",
  },
  {
    id: generateRandomKey(),
    value: "4 Compartment Sink",
    name: "4 Compartment Sink",
  },
  {
    id: generateRandomKey(),
    value: "Bar Sink One Bowl",
    name: "Bar Sink One Bowl",
  },
  {
    id: generateRandomKey(),
    value: "Dipper Well",
    name: "Dipper Well",
  },
  {
    id: generateRandomKey(),
    value: "Dishwasher",
    name: "Dishwasher",
  },
  {
    id: generateRandomKey(),
    value: "Dump Sink One Bowl",
    name: "Dump Sink One Bowl",
  },
  {
    id: generateRandomKey(),
    value: "Floor Drain",
    name: "Floor Drain",
  },
  {
    id: generateRandomKey(),
    value: "Floor Drain Emergency",
    name: "Floor Drain Emergency",
  },
  {
    id: generateRandomKey(),
    value: "Floor Sink",
    name: "Floor Sink",
  },
  {
    id: generateRandomKey(),
    value: "Hand Sink",
    name: "Hand Sink",
  },
  {
    id: generateRandomKey(),
    value: "Ice Machine (with drain)",
    name: "Ice Machine (with drain)",
  },
  {
    id: generateRandomKey(),
    value: "Mop Basin",
    name: "Mop Basin",
  },
  {
    id: generateRandomKey(),
    value: "Pre-Rinse Sink One Bowl",
    name: "Pre-Rinse Sink One Bowl",
  },
  {
    id: generateRandomKey(),
    value: "Prep Sink One Bowl",
    name: "Prep Sink One Bowl",
  },
  {
    id: generateRandomKey(),
    value: "Prep Sink Two Bowls",
    name: "Prep Sink Two Bowls",
  },
  {
    id: generateRandomKey(),
    value: "Soup Kettle",
    name: "Soup Kettle",
  },
  {
    id: generateRandomKey(),
    value: "Warming Table (with drain)",
    name: "Warming Table (with drain)",
  },
  {
    id: generateRandomKey(),
    value: "Wok Range",
    name: "Wok Range",
  },
];

const schema = yup.object({
  fixture: yup.string().required().label("Fixture name"),
  typeSelect: yup.string().required().label("Name Type"),
  gpm: yup.string().required().label("GPM"),
  DFU: yup.string().required().label("DFU"),
  capacity: yup.string().required().label("capacity"),
  quantity: yup.string().required().label("Quantity"),
});

const AddFixtureModal = (props) => {
  const { show, onClose, onSubmit, data } = props;
  console.log("data", data);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      fixture: "",
      typeSelect: "",
      gpm: "",
      DFU: "",
      capacity: "",
      quantity: "",
      ...(data?.row || {}),
    },
  });
  const navigate = useNavigate();
  const handleBtn = (value) => {
    console.log("enen", value);
    onSubmit(value);
    onClose();
  };

  return (
    <div className={`fixture createProject ${show ? "show" : ""}`}>
      <div className="fixture-dialog">
        <div className="fixture-content">
          <div className="fixture-header">
            <h2 style={{}}>{!data ? "Add Fixtures" : "Edit Fixtures"}</h2>
            <p className="subtitle">
              {" "}
              {!data ? "Add" : "Edit"} the fixtures for your project? *
            </p>
            <button type="button" onClick={onClose} className="btn close">
              <img src={Images.icon.closeCircle1} alt="close" />
            </button>
          </div>
          <div className="fixture-body">
            <form onSubmit={handleSubmit(handleBtn)}>
              <InputBox
                name="fixture"
                control={control}
                label="Fixture Name"
                placeholder="Enter Fixture Name"
                required
              />

              <div className="half">
                <SelectBox
                  control={control}
                  name="typeSelect"
                  label="Name Type"
                  selectList={typeList}
                  required
                />
              </div>

              <InputBox
                name="gpm"
                control={control}
                label="GPM"
                placeholder="Enter GPM"
                required
              />

              <div className="address-section">
                <InputBox
                  name="DFU"
                  control={control}
                  label="DFU"
                  placeholder="Enter DFU"
                  required
                />

                <InputBox
                  name="capacity"
                  control={control}
                  label="Capacity"
                  required
                  placeholder="Enter Capacity"
                />

                <div className="form-row">
                  <InputBox
                    name="quantity"
                    control={control}
                    label="Quantity"
                    placeholder="Enter Quantity"
                    required
                  />
                </div>
              </div>

              <div className="button_group">
                <Button label="CANCEL" white onClick={onClose} />
                <Button label="ADD Fixture" onClick={handleSubmit(handleBtn)} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddFixtureModal;
